import * as roles from '../../services/access/roles';
import {getFormValues} from 'redux-form';

export default (state) => {

    const filterForm = getFormValues('chartFilters')(state);

    if (!state.user || !state.user.roles) {
        return null;
    }

    const isAdmin = state.user.roles.indexOf(roles.FBG_WEBMASTER) !== -1;

    if (isAdmin && !state.companies.data.length) {
        return null;
    }

    if(!isAdmin) {
        return state.user.company.id;
    } else {
        return filterForm && filterForm.companyId ?
            findCompanyById(state, filterForm.companyId).id :
            state.companies.data[0].id;
    }

};

const findCompanyById = (state, id) => {
    const match = state.companies.data.filter(c => {
        return c.id === parseInt(id);
    });

    if (! match[0]) {
        throw Error(`Can't find the company by criteria {id: ${id}}`);
    }

    return match[0];
};


// WEBPACK FOOTER //
// ./web/src/reducers/analytics/companyIdSelector.js